import { render } from "./ItemAdjustment_add.vue?vue&type=template&id=5c08b138"
import script from "./ItemAdjustment_add.vue?vue&type=script&lang=js"
export * from "./ItemAdjustment_add.vue?vue&type=script&lang=js"

import "./ItemAdjustment_add.vue?vue&type=style&index=0&id=5c08b138&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__